var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tip-box',{attrs:{"text":_vm.$t('module_external_action_no_event_availabe'),"link-text":_vm.$t('common_learn_more'),"link-url":"/help/article?aid=88151592165197125&q=AEO%20","width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }